// extracted by mini-css-extract-plugin
export default {"component":"ProfilingInfoBox-module__component-kcvl","normalWeight":"ProfilingInfoBox-module__normalWeight-aqHt","desktop":"ProfilingInfoBox-module__desktop-nvaT"};